export default __webpack_public_path__ + "3f213087732422818ea1f7bfc2345c5a.png";